import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';

const FinalCTAPremium = () => {
  return (
    <section className="relative py-32 px-6 overflow-hidden">
      {/* Premium gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-teal-500 via-teal-400 to-teal-600"></div>
      
      {/* Sophisticated overlay pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '48px 48px'
        }}></div>
      </div>

      {/* Floating orbs */}
      <div className="absolute top-20 left-20 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-float"></div>
      <div className="absolute bottom-20 right-20 w-96 h-96 bg-teal-300/20 rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }}></div>

      <div className="max-w-5xl mx-auto text-center relative z-10">
        {/* Premium badge */}
        <div className="inline-flex items-center gap-3 px-6 py-3 bg-white/10 backdrop-blur-md rounded-full border border-white/20 mb-8 animate-fade-in">
          <div className="w-2 h-2 rounded-full bg-white animate-pulse"></div>
          <span className="text-sm font-light text-white tracking-wide">TRANSFORM YOUR PRACTICE TODAY</span>
        </div>

        {/* Powerful headline */}
        <h2 className="text-5xl md:text-6xl lg:text-7xl font-light text-white mb-8 leading-tight" style={{ fontFamily: 'Raleway, sans-serif' }}>
          Ready to Lead the Future
          <br />
          <span className="font-normal">of Regenerative Medicine?</span>
        </h2>

        {/* Compelling value proposition */}
        <p className="text-xl md:text-2xl text-white/90 font-light mb-12 max-w-3xl mx-auto leading-relaxed">
          Join the global network of pioneering clinics delivering breakthrough results with MCT technology
        </p>

        {/* Value points */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center mb-12 text-white/90">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5" strokeWidth={1.5} />
            <span className="font-light">Expert Implementation Support</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5" strokeWidth={1.5} />
            <span className="font-light">Comprehensive Training</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5" strokeWidth={1.5} />
            <span className="font-light">Proven ROI</span>
          </div>
        </div>

        {/* Premium CTA buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/contact"
            className="group inline-flex items-center gap-3 bg-white hover:bg-gray-50 text-teal-600 px-12 py-6 rounded-2xl font-medium transition-all duration-300 shadow-2xl hover:scale-[1.02] text-lg"
          >
            Schedule Your Consultation
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" strokeWidth={2} />
          </Link>
          <a
            href="tel:+1234567890"
            className="inline-flex items-center gap-3 bg-transparent hover:bg-white/10 text-white border-2 border-white/30 hover:border-white/50 px-12 py-6 rounded-2xl font-light transition-all duration-300 backdrop-blur-sm text-lg"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            Call Us Now
          </a>
        </div>

        {/* Trust indicator */}
        <p className="mt-12 text-white/70 text-sm font-light">
          Typical response time: Within 24 hours • No commitment required
        </p>
      </div>
    </section>
  );
};

export default FinalCTAPremium;
